import { styled } from 'styled-components'

export const StyledActionsWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
`
